import { FormProps, ThemeProps, withTheme } from '@rjsf/core';
import { FormContextType, RJSFSchema, StrictRJSFSchema } from '@rjsf/utils';
import { ComponentType, memo } from 'react';

import Fields, { generateFields } from './fields';
import Templates, { generateTemplates } from './templates';
import Widgets, { generateWidgets } from './widgets';

export function generateTheme<
	T = any,
	S extends StrictRJSFSchema = RJSFSchema,
	F extends FormContextType = any
>(): ThemeProps<T, S, F> {
	return {
		templates: generateTemplates<T, S, F>(),
		widgets: generateWidgets<T, S, F>(),
		fields: generateFields<T, S, F>(),
	};
}

const Theme = generateTheme();

export function generateForm<
	T = any,
	S extends StrictRJSFSchema = RJSFSchema,
	F extends FormContextType = any
>(): ComponentType<FormProps<T, S, F>> {
	return withTheme<T, S, F>(generateTheme<T, S, F>());
}

const Form = generateForm();

export { Fields, generateTemplates, generateWidgets, Templates, Theme, Widgets };
export default memo(Form);
